<template>
<div>
  <Modal
    v-model="isShow"
    :width="900"
    :loading="loading"
    :mask-closable="false"
  >
    <h3 slot="header" class="modal-header">添加运营标签</h3>
    <Form
			class="repeatForm"
			:ref="'form'+index"
			:model="itemP"
			:rules="ruleValidate"
			:label-width="110"
			v-for="(itemP,index) in labelEntities"
			:key="'index2'+index"
			>
      <Row >
				<Col span="10">
					<FormItem prop="labelName" label="标签名称">
						<Input v-model="itemP.labelName" placeholder="请输入标签名称"></Input>
					</FormItem>
				</Col>
				<Col span="10">
					<FormItem prop="labelOrder" label="显示顺序">
						<Input v-model="itemP.labelOrder" placeholder="请输入大于0的整数"></Input>
					</FormItem>
				</Col>
      </Row>
			<Row>
				<Col span="10">
					<FormItem prop="remark" label="描述">
						<Input v-model="itemP.remark" placeholder="请输入不超过20个字"></Input>
					</FormItem>
				</Col>
        <Col span="10">
          <FormItem prop="picUrl" label="背景图片">
						<div class="imgBox">
						<div v-if="itemP.picUrl" style="float:left">
							<Col v-for="(item,index2) in itemP.picUrl" :key="'i1'+index2">
								<img class="upload" :src="item.attachmentImgUrl">
								<Button size="small" style="margin:16px 8px 0;float:left" @click="deleteImg(index2,index)">删除</Button>
							</Col>
						</div>
           <Upload
						:class="['upload',{error: itemP.picUrl.length===0&&!itemP.validateImages}]"
            :action="baseUrl+'/file/uploadFile'"
            :on-success="handleSuccess"
            :headers="{'Access-Token':token}"
						:data="{type:index}"
            :show-upload-list="false"
            :on-error="handleError"
            :format="['jpg','jpeg','png']"
            :on-format-error="formatError"
            icon="ios-cloud-upload-outline"
           >
           <Icon :class="{error_plus_icon: itemP.picUrl.length===0&&!itemP.validateImages}" type="ios-plus-empty" size="30" style="vertical-align: middle"></Icon>
          </Upload>
					</div>
					<p v-if="itemP.picUrl.length===0&&!itemP.validateImages" class="error_msg">请上传背景图</p>
          </FormItem>
        </Col>

      </Row>
      <Row>
				<Col span="10">
					<FormItem prop="labelSecondaryType"  label="标签类型">
						<Select v-model="itemP.labelSecondaryType"  placeholder="请选择">
							<Option value="">请选择</Option>
							<Option v-for="item in secondaryYYType" :key="item.value+'keyYY'" :value="item.value">{{item.text}}</Option>
						</Select>
					</FormItem>
				</Col>

        <Col span="10">
          <FormItem prop="link" label="跳转链接">
						<Input v-model="itemP.link"></Input>
          </FormItem>
        </Col>
				<Col span="10">
          <FormItem prop="highLight" label="是否高亮">
            <i-switch v-model="itemP.highLightBoolean">
								<span slot="open">是</span>
								<span slot="close">否</span>
						</i-switch>
          </FormItem>
        </Col>
				<Col span="10" v-if="itemP.labelSecondaryType === 7">
          <FormItem prop="couponLabelBoolean" label="是否为优惠券活动">
            <i-switch v-model="itemP.couponLabelBoolean">
								<span slot="open">是</span>
								<span slot="close">否</span>
						</i-switch>
          </FormItem>
        </Col>
				<Col span="4" v-if="index">
					<a style="line-height:32px;margin-left:10px" @click.stop="deleteItem(itemP,index)"> 删除</a>
				</Col>
      </Row>
    </Form>
		<Row>
			<Col span="4">
				<a style="line-height:32px;margin-left:10px" @click.stop="addItem"> + 继续添加</a>
			</Col>
		</Row>
		<!-- <Form
			ref="addData"
			:model="addData"
			:rules="ruleValidate2"
			:label-width="180">
      <Row class="max64">
        <Col span="12">
          <FormItem prop="projectFids" label="适用项目">
            <Select v-model="addData.projectFids" placeholder="请选择" multiple filterable @on-change="selectProject">
							<Option value="all">全部选择</Option>
							<Option v-for="(item,index) in projects" :key="'s4'+index" :value="item.value">{{item.text}}</Option>
						</Select>
          <span class="count" v-if="addData.projectFids.length">{{addData.projectH'ou's'rTypeFids.length}}</span>
          </FormItem>
        </Col>
				<Col span="8">
          <FormItem prop="syncHousetype" label="标签是否同步在房型展示">
            <i-switch v-model="addData.syncHousetypeBoolean">
								<span slot="open">是</span>
								<span slot="close">否</span>
						</i-switch>
          </FormItem>
        </Col>
      </Row>
		</Form> -->
		<Form
			ref="addData"
			:model="addData"
			:rules="ruleValidate2"
			:label-width="120"
		>
			<Row class="max64">
				<Col span="10">
					<FormItem prop="labelShowPosition" label="标签展示位置：">
						<Checkbox-group v-model="addData.labelShowPosition">
								<Checkbox label="1">项目</Checkbox>
								<Checkbox label="2">房型</Checkbox>
						</Checkbox-group>
					</FormItem>
				</Col>
			</Row>
			<Row class="max64">
				<Col span="10">
          <FormItem prop="projectFids" label="请选择项目：" v-if="addData.labelShowPosition.length > 0">
            <Select v-model="addData.projectFids" placeholder="请选择" multiple filterable @on-change="selectProject">
							<Option value="all">全部选择</Option>
							<Option v-for="(item,index) in projects" :key="'s4'+index" :value="item.value">{{item.text}}</Option>
						</Select>
						<span class="count" v-if="addData.projectFids.length">{{addData.projectFids.length}}</span>
          </FormItem>
        </Col>
				<Col span="10" v-if="addData.labelShowPosition.indexOf('2')!==-1">
					<FormItem prop="houseTypeFids" label="请选择房型：">
						<Select v-model="addData.houseTypeFids" placeholder="请选择" multiple filterable @on-change="selectHouse">
							<Option value="all">全部选择</Option>
							<Option v-for="(item,index) in houseTypes" :key="'s4'+index" :value="item.value">{{item.text}}</Option>
						</Select>
						<span class="count" v-if="addData.houseTypeFids.length">{{addData.houseTypeFids.length}}</span>
					</FormItem>
				</Col>
			</Row>
			<div class="red">注意：如需将标签配置到房间，请前往<span @click="goSet()">门店配置>门店信息>房源信息>批量添加房间标签</span></div>
		</Form>
		<div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="ok">
        <span>保存</span>
      </Button>
    </div>
  </Modal>
	<Modal
		class="mask"
		v-model="isModalShow"
    :width="400"
    :loading="loading"
    :mask-closable="false"
		@on-ok="save"
    @on-cancel="cancel"
	>
		<h3 slot="header" class="modal-header">消息提醒</h3>
		<div class="tip">{{tips}}</div>
	</Modal>
	</div>
</template>


<script>
import {getToken} from "utils/auth";
import {getBaseUrl} from "utils/public";
import {saveOrEdit,getHoseTypeInfoListByProId} from 'api/labelmanage'
export default {
	props:{
		n:{
			type:Number,
			default:0
		},
		secondaryType:{
			type:Array,
			default(){
        return []
      }
		},
		secondaryYYType:{
			type:Array,
			default(){
				return []
			}

		},
		applyObject:{
			type:Array,
			default(){
        return []
      }
		},
		// houseTypes:{
		// 	type:Array,
		// 	default(){
    //     return []
    //   }
		// },
		projects:{
			type:Array,
			default(){
        return []
      }
		}
	},
  data(){
		const validates = (rule, value, callback) => {
			const pattern = /^\+?[1-9]\d*$/
			if (!pattern.test(value)) {
				callback(new Error('请填写显示顺序且为大于0的整数'));
			} else {
				callback();
			}
		};
		return{
			ruleValidate:{
        labelName:[
          { required: true, message: '请输入标签名', trigger: 'blur',type:'string'}
				],
        labelOrder:[
          { required: true, message: '请输入大于0的整数', trigger: 'blur',type:'number',validator: validates}
				],
				remark:[
          { required: true, message: '请输入不超过20个字的描述', max:20, trigger: 'blur',type:'string'}
				],
				picUrl:[
					{ required: true, message: ' '}
				],
				labelSecondaryType:[
					{ required: true, message: '请选择标签类型', trigger: 'blur',type:'number',}
				],
			},
			ruleValidate2:{
				projectFids:[
					{ required: true, message: '请选择项目', trigger: 'change',type:'array'}
				],
				houseTypeFids:[
					{ required: true, message: '请选择房型', trigger: 'change',type:'array'}
				],
				labelShowPosition: [
					{ required: true, message: '请选择标签展示位置', trigger: 'change',type:'array' }
				]
			},
			token:'',
      baseUrl:'',
			loading:false,
			isShow:false,
			addData:{
				labelShowPosition:[],
				// syncHousetypeBoolean:false,
				projectFids:[],
				houseTypeFids:[],
				projectHouseTypeFids:[]
			},
			isModalShow:false,
			tips:'提交后标签将在页面上显示！',
			itemP:[],
			labelEntities:[],
			maxnum:1,
			imgIndex:0,
			validateImages:true,
			selectedAll:false,
			selectedAll2:false,
			houseTypes:[]
		}
	},
	created() {
    this.baseUrl = getBaseUrl()
    this.token = getToken()
  },
	watch:{
		n(){
			if(this.$refs['form0']){
        this.$refs['form0'][0].resetFields()
      }
			this.$refs['addData'].resetFields()
			this.addData = {
				labelShowPosition:[],
				projectFids:[],
				houseTypeFids:[],
				projectHouseTypeFids:[]
			},
			this.labelEntities =[
        {
					validateImages:true,
					labelType:5,
          labelName:'',
          labelOrder:'',
					link:'',
					remark:'',
					highLightBoolean:true,
					couponLabelBoolean:false,
          picUrl:[],
					labelSecondaryType:null
        }
      ],
			this.isShow = true;
			this.selectedAll = false
		},
	},
	methods:{
		goSet(){
			this.$router.push({path:'/app/projects'})
			this.isShow = false
		},
		selectProject(value){
			let isCheck = false
			value.forEach(ele=>{
				if(ele==='all'){
					isCheck = true
					this.selectedAll = !this.selectedAll
				}
			})
			if(isCheck&&this.selectedAll){
				const val = []
				this.projects.forEach(ele=>{
					val.push(ele.value)
				})
				this.addData.projectFids = val;
			}
			if(isCheck && !this.selectedAll){
				this.addData.projectFids = []
			}
			// 有2的时候才可以
			if(this.addData.labelShowPosition.indexOf('2')!==-1)
			this.getHouseProject();
		},
		getHouseProject(){
			getHoseTypeInfoListByProId({
				projectIds:this.addData.projectFids
			}).then(res => {
				console.log(res)
				this.houseTypes = res.data.houseTypes;
			})
		},
		selectHouse(value){
			let isCheck = false
			value.forEach(ele=>{
				if(ele==='all'){
					isCheck = true
					this.selectedAll2 = !this.selectedAll2
				}
			})
			if(isCheck&&this.selectedAll2){
				const val = []
				this.houseTypes.forEach(ele=>{
					val.push(ele.value)
				})
				this.addData.houseTypeFids = val;
			}
			if(isCheck && !this.selectedAll2){
				this.addData.houseTypeFids = []
			}
		},

		deleteImg(index2,indexP){
			this.labelEntities[indexP].validateImages = false
			this.labelEntities.forEach((ele,index)=>{
				if(index == indexP){
					ele.picUrl.splice(index2,1)
				}
			})
    },
		handleSuccess(res){
			const index = res.data.type;
			if(this.labelEntities[index].picUrl.length>=this.maxnum ){
					this.$Message.error('最多上传'+this.maxnum+'张图片')
					this.changeLoading();
					return
			}
			this.labelEntities[index].picUrl.push({
				fid:res.data.fid,
				attachmentImgUrl:res.data.url
			})
		},
		formatError(){
      this.$Message.info('请上传jpg、jpeg、png类型文件')
    },
		handleError(){
			return
    },
		deleteItem(item,index){
      this.$Modal.confirm({
        content: '<p>确认删除？</p>',
        onOk:() => {
          this.labelEntities.splice(index,1)
        }
      })
		},
		addItem(){
      this.labelEntities.push(
        {
					validateImages:true,
					labelType:5,
          labelName:'',
          labelOrder:'',
					link:'',
					remark:'',
					highLightBoolean:true,
					couponLabelBoolean:false,
          picUrl:[],
					labelSecondaryType:null,
        }
      )
    },
		ok(){
      let validate = true
      for (const i in this.$refs) {
        if(this.$refs[i] instanceof Array){
          this.$refs[i].forEach(item => {
            item.validate(bool => {
              !bool && (validate = bool)
            })
          })
        }
			}
			this.labelEntities.forEach((ele)=>{
				if(ele.picUrl.length === 0){
					ele.validateImages = false
					validate = false
				}
			})
      this.$refs['addData'].validate( bool => {
        if(bool){
					console.log()
        } else{
          validate = false
          this.changeLoading();
        }
      })
      if (!validate) {
        this.changeLoading()
        return
			}
			this.isModalShow = true
    },
		save(){
			// this.addData.syncHousetype = this.addData.syncHousetypeBoolean===true?1:0
			// applyType 1：项目 2 房型 3：项目+房型 4：房间
			let applyType;
			if(this.addData.labelShowPosition.indexOf('2')!==-1){
				if(this.addData.labelShowPosition.length > 1){
					applyType = 3
				} else{
					applyType = 2
				}
			} else {
				applyType = 1
			}
			this.labelEntities.forEach(ele=>{
				ele.highLight = ele.highLightBoolean===true?1:0
				ele.couponLabel = ele.couponLabelBoolean === true?1:0
			})
			this.addData.projectHouseTypeFids = this.addData.projectFids;
			const params = {
				applyType:applyType,
				labelEntities:this.labelEntities,
				...this.addData
			}
			saveOrEdit(params)
			.then(res=>{
				if(res.code === 0){
					this.$emit('done')
					this.$Message.success('保存成功')
				} else{
					// this.$Message.error('保存失败')
				}
			})
			.catch(()=>{
				return
				// this.$Message.error('保存失败')
			})
			.finally(()=>{
				this.isModalShow = false
				this.isShow = false;
			})
		},
		cancel(){
			this.isModalShow = false
		},
		handleCancel(){
			this.isShow = false;
		},
		changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
	}
}
</script>
<style scoped>
	.red{
		color: red;
		margin-left: 20px;
	}
	.red span{
		cursor: pointer;
		text-decoration: underline;
	}
	.imgBox{
		width: 100%;
    height: 40px;
	}
	.error_msg{
		width: 90px;
		height: 0;
		line-height: 18px;
		color: #F56356;
	}
	.error_plus_icon{
		color: #F56356
	}
	.error {
    border-color: #F56356!important;
  }
	.tip{
		font-size: 13px;
		text-align: center;
	}
	.upload {
    display: block;
		float: left;
    width: 60px;
    height: 40px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
		line-height: 40px;
  }
	.repeatForm{
		padding-top: 24px;
		width: 100%;
		height: auto;
		border: 1px dashed darkgrey;
		margin-bottom: 20px;
	}
	.count {
    display: inline-block;
    min-width: 16px;
    min-height: 16px;
    position: absolute;
    top: -6px;
    right: -6px;
    background: #cfa868;
    color: #ffffff;
    border-radius: 100%;
    line-height: 15px;
    text-align: center;
    font-weight: 600;
  }
</style>
